export default class PermisoModel {
    idNPermiso: number | null;
    fkNTipoUsuario: number | null;
    fkNTipoVariable: number | null;
    fldBVer: boolean | null;
    fldBEditar: boolean | null;
    tipoVariable: string | null;
    tipoSupervisor: string | null;
    version: string | null;
    tipoElemento: string | null;
    tipoUsuario: string | null;
    idNTipoSupervisor: number | null;
    idNVersionSupervisor: number | null;
    idNTipoElemento: number | null;

    constructor() {
        this.idNPermiso = null;
        this.fkNTipoUsuario = null;
        this.fkNTipoVariable = null;
        this.fldBVer = null;
        this.fldBEditar = null;
        this.tipoVariable = null;
        this.tipoSupervisor = null;
        this.version = null;
        this.tipoElemento = null;
        this.tipoUsuario = null;
        this.idNTipoSupervisor = null;
        this.idNVersionSupervisor = null;
        this.idNTipoElemento = null;
    }
}